import React from 'react'
import { Link } from 'react-router-dom'
import Header from'../Component/Header';
import Footer from'../Component/Footer';  
import { getPrincipalMessage } from "../Service/Api"; 
import LazyLoad from 'react-lazyload';
import { useState ,useEffect } from 'react';
const PrincipalMessage = () => {
  useEffect(() => {
    document.title = 'Principal Message-  St. Francis Xavier School';  
}, []); 
    const [data, setData] = useState([]);
    useEffect(() => {
     const fetchData = async () => {
       try {
         const msgdata = await getPrincipalMessage();
        const data = msgdata.filter((item) => item.category === "Principal");
        
         setData(data);
       } catch (error) {
         console.error("Error fetching online registration data:", error);
       }  
     };
     fetchData();
   }, []);
    return (
        <>
        <Header/>
        <div className="innerslide">
              <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li>   
                <li>  Message</li>
                <li>Principal's Message</li>
              </ul>
          </div>
            <section className="innerbody">
               <div className='container'>
                <div className='row'>
                {data.length > 0 && (
                    <div className="clearfix">
                       <LazyLoad> <img 
                        src={`https://webapi.entab.info/api/image/${data[0].attachments}`} 
                        className="img-fluid col-sm-12 col-md-4 float-md-end mb-3 msgimg" 
                        alt={data[0].name || 'Image'}
                      /></LazyLoad>
                      <p><div dangerouslySetInnerHTML={{ __html: data[0].message }} /></p> 
                      <p className="name">
                        {data[0].name}<span> {data[0].category} </span>
                      </p>
                    </div>
                  )}

                  {data.length === 0  && (
                    <div className="clearfix">
                       <LazyLoad> <img 
                        src="https://webapi.entab.info/api/image/SFXH/public/images/default.png" 
                        className="img-fluid col-sm-12 col-md-4 float-md-end mb-3 msgimg" 
                        alt=""
                      /></LazyLoad>
                      <p>Finding itself in a conducive environment, peacock spreads its wings to dance, thus exhibiting its innate
                      talent. At St. Xavier High School we, through academics, sports and co-curricular activities, try to
                      provide healthy environment, facilitating the discovery and nourishment of God-given talents and virtues
                      of our students. The first batch to answer the recently concluded CBSE board exam 2023 is the pride and
                      prestige of our dedicated staff. We strive for intellectual, moral, emotional and physical development
                      of all our students. We stand for gender equality, non-violence and love for nature.</p>
                  <p>Enhancing education with technology based methods of teaching make our students’ learning experience a
                      memorable one. The <strong>‘good morning’</strong> or <strong>‘good afternoon’</strong> wishes, not just
                      in school, but also outside the school campus, make us realize how connected the students are to us.
                      Yes, natural resources are depleting but let us discover and develop the most precious resource, the
                      human resource through education so that all other resources are shared and cared for.</p>
                      <p>God Bless you !<br />  Warmest Regards,<br /></p>
                      <p className="name"> Fr. Vidya Sagar Madanu
                         <span>  Principal </span>
                      </p>
                    </div>
                  )}
                </div> 
                </div> 
             </section>
            <Footer/>
        </>
    )
}

export default PrincipalMessage